// src/styles/siteClasses.js
export const h1 = "text-white text-4xl font-bold mb-10"
export const h2 = "text-white text-2xl font-bold mb-6"
export const h3 = "text-white text-xl font-bold mb-4"
export const linksClass = "text-yellow-400 hover:text-yellow-500 no-underline";
export const featureImageClass = 'w-full h-auto mb-4 rounded-md'
export const imageClass = 'h-auto mb-4 rounded-md'